import script from "./BidViewCurrency.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewCurrency.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewCurrency.vue?vue&type=style&index=0&id=7388bc67&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7388bc67"]])

export default __exports__